import * as CONSTANTS from '../modules/constants';

var currentScroll;

export function lockBody() {
    currentScroll = window.pageYOffset;
    CONSTANTS.GLOBAL_BODY.classList.add('locked');
    CONSTANTS.GLOBAL_BODY.style.top = '-' + currentScroll + 'px';
}

export function unlockBody() {
    CONSTANTS.GLOBAL_BODY.classList.remove('locked');
    window.scrollTo(0, currentScroll);
}



// WEBPACK FOOTER //
// ./Static/javascript/modules/lock-body.ts